import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adv-user-messages',
  templateUrl: './adv-user-messages.component.html',
  styleUrls: ['./adv-user-messages.component.css']
})
export class AdvUserMessagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
